import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

if( $( '.amenities-map-section' ).length ){
  mapboxgl.accessToken = 'pk.eyJ1IjoiZmxpcHBkZXZzIiwiYSI6ImNrc2hxc2x0ZDF3eGQyb29hZDNndWhuZXcifQ.NLQN5AjdofpVMB8SBRgDgA';
  const mapInfo = document.querySelectorAll( '.map-info' )
  const mapCenter = [ -113.406509, 53.352426 ];
  const mapZoom = 13;
  
  
  const map = new mapboxgl.Map( {
  
    container: 'map', // container ID
    style: 'mapbox://styles/flippdevs/clbxwcyxc000i14qr5zozbd97', // style URL
    center: mapCenter, // starting position [lng, lat]
    zoom: mapZoom, // starting zoom
    scrollZoom: false, // scrolling wheel
  } );

  const mapLocatorDiv = document.createElement( 'div' )
    mapLocatorDiv.className = 'map-locator-logo';

  const mapLocatorPopUp = new mapboxgl.Popup( { offset: 2 } ) // add popups
    .setHTML(
      `<div class="map-box-heading">` +
        `<h2 class="headline-5">Azur</h2>` +
        `<div class="map-box-address">3726 41 Ave<br>Beaumont, AB T4X 1L8<br>Canada</div>` +
        `<div class="map-box-link"><a target="_blank" href="https://maps.app.goo.gl/hpzQo3hGEp1pE3ag9" tabindex="0">View on Google Maps</a></div>` +
      `</div>`
    )

  const mapLocatorMarker = new mapboxgl.Marker( mapLocatorDiv )
    .setLngLat( mapCenter )
    .setPopup( mapLocatorPopUp )
    .addTo( map );

  mapInfo.forEach( ( elem, index ) => {

    // Create Marker Element
    const el = document.createElement( 'div' )
    el.className = 'marker'
    el.dataset.slug = elem.dataset.slug

    // Create Number for Marker Element
    const mapMarkerNumber = document.createElement( 'p' )
    mapMarkerNumber.className = 'map-marker-number'
    mapMarkerNumber.textContent = $( mapInfo ).find( '.map-number' )[index].textContent
    
    el.appendChild( mapMarkerNumber ) // Add to Marker Element

    const popUp = new mapboxgl.Popup( { offset: 2 } ) // add popups
    .setHTML(
      `<h2 class="headline-4 map-box-heading">${ $( mapInfo ).find( '.map-title' )[index].textContent }</h2>`
    )

    // Create a new marker.
    const marker = new mapboxgl.Marker(el)
    .setLngLat( [$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent] )
    .setPopup( popUp )
    .addTo( map );
    
  } )

  // Display Markers When Legend Items are Clicked
  const legendItem = document.querySelectorAll( '.map-legend-title-container' )
  const legendMarker = document.querySelectorAll( '.marker' )

  legendMarker.forEach( ( elem, index ) => {

    elem.addEventListener('click', function () {
      map.flyTo({
        center: [$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent],
        zoom: 15,
      })
    })

    $( legendItem ).on( 'click', function() {

      map.flyTo({
        center: mapCenter,
        zoom: mapZoom,
      })

      if( $(this).data().slug === $(elem).data().slug ) {
        $(elem).toggleClass( 'marker-toggle' )
        $( '.map-box-heading' ).parent().remove()
      } else {
        $(elem).removeClass( 'marker-toggle' )
      }
    } )
    
  } )

  

  // Linking Legend Marker to Pop-Up on Map
  const mapLegendItem = document.querySelectorAll( '.legend-item-wrapper' )

  mapLegendItem.forEach( ( elem, index ) => {
    elem.addEventListener( 'click', ( e ) => {
      e.preventDefault();
      $( '.mapboxgl-popup' ).remove() // Remove all existing pop ups

      // Add popup
      const legendPopUp = new mapboxgl.Popup( { offset: 2, focusAfterOpen: false } )
      .setHTML(
        `<h2 class="legend-popup p map-box-heading text-black">${ $( mapInfo ).find( '.map-title' )[index].textContent }</h2>`
      )
      .setLngLat([$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent])
      .addTo( map )

      map.flyTo({
        center:[$( mapInfo ).find( '.map-lon' )[index].textContent, $( mapInfo ).find( '.map-lat' )[index].textContent],
        zoom: 15,
        essential: true
      })

    } )
  } )

  // Accordion
  $('.accordion .title').on( 'click', function(e) {
    e.preventDefault();

    var $this = $(this);
    var accordion = $this.parent();
    var content = $this.next();
    var height = 71;

    if( accordion.prev().length ) {
      var heightDiff = accordion.prev().height() - accordion.height();
      var position = accordion.prev().position().top + $( '.map-legend' ).scrollTop() - (height * 2) 
      //this gets the top value of the previous accordion + the amount the legend has scrolled 
      //- the height * 2 show it shows the previous accordion option
      $( '.map-legend' ).animate( {
        scrollTop: position
      }, 250 )
    } else {
      var position = $this.position().top - content[0].scrollHeight - height
      //for the first accordion item, it's grabbing the position top, minusing the height of its 
      //content container and the height of the title
      $( '.map-legend' ).animate( {
        scrollTop: position
      }, 250 )
    }

    accordion.parent().find('.text-content').css('max-height', '0');

    if (accordion.hasClass('open')) {
      accordion.removeClass('open');
    } else {
      accordion.siblings().removeClass('open');
      accordion.addClass('open');
      content.css('max-height', content[0].scrollHeight);
    }    
  });

}